"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassLabel = exports.ClassCategory = void 0;
var ClassCategory;
(function (ClassCategory) {
    ClassCategory["ClickOnGeneralTab"] = "ClickOnGeneralTab";
    ClassCategory["ClickOnMainModulesTab"] = "ClickOnMainModulesTab";
    ClassCategory["ClickOnExtraModulesTab"] = "ClickOnExtraModulesTab";
    ClassCategory["ClickOnUsersTab"] = "ClickOnUsersTab";
    ClassCategory["ClickCreateNewOfferButton"] = "ClickCreateNewOfferButton";
    ClassCategory["CancelDeleteClass"] = "CancelDeleteClass";
    ClassCategory["ConfirmDeleteClass"] = "ConfirmDeleteClass";
    ClassCategory["SelectClassModule"] = "SelectClassModule";
    ClassCategory["UnselectClassModule"] = "UnselectClassModule";
    ClassCategory["SelectAllClassModule"] = "SelectAllClassModule";
    ClassCategory["UnselectAllClassModule"] = "UnselectAllClassModule";
    ClassCategory["SaveMainClassModule"] = "SaveMainClassModules";
    ClassCategory["SaveExtraClassModule"] = "SaveExtraClassModule";
    ClassCategory["CreateClass"] = "CreateClass";
    ClassCategory["UpdateClass"] = "UpdateClass";
})(ClassCategory || (exports.ClassCategory = ClassCategory = {}));
var ClassLabel;
(function (ClassLabel) {
    ClassLabel["ClassId"] = "ClassId";
})(ClassLabel || (exports.ClassLabel = ClassLabel = {}));
